import { Button } from "@/components/ui/button";
import type { FC } from "react";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
} from "../ui/drawer";

type Props = {
  title: string;
  description: string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDisabled?: boolean;
  cancelWording: string;
  confirmWording: string;
};

const ConfirmationDrawer: FC<Props> = ({
  title,
  description,
  open,
  onClose,
  onConfirm,
  isDisabled,
  confirmWording,
  cancelWording,
}) => {
  return (
    <Drawer open={open} onClose={() => onClose()}>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle>{title}</DrawerTitle>
        </DrawerHeader>

        <DrawerDescription className="pl-[24px]">
          {description}
        </DrawerDescription>

        <DrawerFooter className="grid grid-cols-2 gap-[16px]">
          <Button
            className="w-[100%]"
            variant="secondaryFilled"
            onClick={() => onClose()}
          >
            {cancelWording}
          </Button>
          <Button
            className="w-[100%]"
            disabled={isDisabled}
            onClick={() => onConfirm()}
          >
            {confirmWording}
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};

export default ConfirmationDrawer;
